import * as React from 'react';
import { Table } from 'antd';
import { default as styled } from 'styled-components';
import {
  blueLightLinearColor,
  lightBlackColor,
  middleBlackColor,
  tableShortBorderColor,
  weightGreyColor,
  whiteColor,
  borderColor,
  titleColor,
  contentFontColor,
  blueColor
} from '@config/index';

import './table.less';

export const NiTable: typeof Table = styled(Table)`
  &.ant-table-wrapper {
    .ant-table {
      .ant-table-content {
        border: 1px solid ${borderColor};

        table {
          .ant-table-thead {
            tr {
              border-top: 0;
              border-bottom: 1px solid ${borderColor};

              th {
                background: ${weightGreyColor};
                font-weight: normal;
                padding: 9px 16px;
                color: ${titleColor};

                &:before {
                  background-color: inherit;
                }
              }

              th.hide {
                &::after {
                  display: none;
                }
              }


            }
          }
        }

        .ant-table-tbody {
          tr {
            
            &:not(:last-of-type) {
              td {
                border-bottom: 1px solid ${borderColor};
              }
            }

            td {
              border-bottom:none;
              word-break: break-all;
              padding: 9px 16px;
              font-size: 14px;
              color: ${contentFontColor};
              min-height: 40px;
            }

            .icon-area {
              .hidden-icon,
              .delete-btn,
              .download-btn {
                margin-left:16px;
                visibility: hidden;
              }
            }

            &:hover:not(.del) {
              .icon-area {
                .hidden-icon,
                .delete-btn,
                .download-btn {
                  visibility: visible;
                }
              }
            }

            &.del{
              .icon-area {
                .delete-btn {
                  visibility: hidden;
                }
              }
            }

            &.normal,
            &.add {
              .icon-area {
                .private-conflict-icon {
                  visibility:hidden
                }
              }
            }

            .hide {
              >div {
                visibility: hidden;
              }
            }

            &:hover {
              .hide {
                >div {
                  visibility: visible;
                }
              }
            }
          }
        }

        .ant-table-placeholder {
          border-top: 1px solid ${lightBlackColor};
          border-bottom: 0;

          .ant-empty {
            margin: 0;

            .ant-empty-image {
              display: none;
            }
          }
        }
      }
    }

    .ant-pagination {
      .ant-pagination-item-active {
        border: ${blueColor} 1px solid;
        background: inherit;

        >a {
          color: ${blueColor};
        }
      }

      li a {
        color: ${middleBlackColor};
      }
    }
  }
` as any;
